import React, { ComponentProps } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { PrivilegedGroupsEditView } from './views/PrivilegedGroupsEditView';
import { PrivilegedGroupsDefaultView } from './views/PrivilegedGroupsDefaultView';
import { PrivilegedGroupsInteractions } from './partials/PrivilegedGroupsInteractions';

export type PrivilegedGroupsBlockProps = Views<
  DefaultView<PrivilegedGroupsDefaultView> & OptionalEditView<PrivilegedGroupsEditView>
>;

function PrivilegedGroups({ views, activeView = 'default' }: PrivilegedGroupsBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  return active ? (
    <PrivilegedGroupsInteractions views={views} activeView={activeView} />
  ) : (
    <PrivilegedGroupsDefaultView {...views.default} />
  );
}

export const PrivilegedGroupsBlock = asFetchableBlock(PrivilegedGroups, BlockType.privilegedgroups);
export type PrivilegedGroupsBlock = ComponentProps<typeof PrivilegedGroupsBlock>;
